module.exports = __webpack_public_path__ + "static/img/11.3c26265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/11.jpg
// module id = a0RZ
// module chunks = 0